import { GlobeIcon } from "../icon";

export interface FlagProps {
  countryCode: string;
  label?: string;
}

const Flag = ({ countryCode, label }: FlagProps) => {
  const getSvgPath = (code: string) =>
    `/assets/flags/${code.toLowerCase()}.svg`;

  return (
    <span className="flex min-w-10 flex-row">
      {countryCode === "GLOBAL" ? (
        <GlobeIcon id="globe-icon" title="Global" />
      ) : (
        <img
          alt={countryCode}
          className="h-4 w-7"
          src={getSvgPath(countryCode)}
          style={{ fontSize: "1.5em", lineHeight: "1.5em" }}
          title={countryCode}
        />
      )}
      {label && (
        <span
          className={`text-xs tracking-wider ${countryCode === "GLOBAL" ? "ml-2" : ""}`}
        >
          {label}
        </span>
      )}
    </span>
  );
};

Flag.displayName = "Flag";

export { Flag };
